import { GET_FORM_DATA } from "../actions";

let initialState = {
    form_data: {}
}

export const mainReducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_FORM_DATA:
            return state.form_data
        default:
            return state;
    }
}